import React from "react";
import { Box, Typography } from "@mui/material";
import { CustomTooltip } from "@web-applications/allinga-web-components";
import { useTranslation } from "react-i18next";

type Props = {
  total: number;
  used: number;
};

export default function QuotaPercent({ total, used }: Props) {

  const { t } = useTranslation();
  
  const hasData = total > 0;
  const percentage = hasData ? (used / total) * 100 : 0;

  const getDotColor = (): string => {
    if (!hasData) return "success.main";
    if (percentage >= 90) return "error.main";
    if (percentage < 90 && percentage >= 80) return "warning.main";
    return "success.main";
  };

  return (
    <CustomTooltip title={t("tts.quotaTooltipInfo")}
      placement="bottom"
      disableHoverListener={false}
      forceShow
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: getDotColor(),
          }}
        />
        <Typography variant="body2" fontWeight={400}>
          {hasData ? `${percentage.toFixed(0)}% ${t("tts.quotaCreditUsedInfo")}` : t("tts.infiniteCreditInfo")}
        </Typography>
      </Box>
    </CustomTooltip>

  );
}
